import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import { Modal } from "antd";
import { observer } from "mobx-react-lite";
import { useModalStore } from "@/hooks/Modal/hooks";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { useCompanySettingStore, useGlobalStore } from "@/store/hooks";
import {
    getValidOrders,
    preValidateAndFilterOrdersOrExecOperation,
} from "@/scenes/OrderManagement/components/dialogs/DropShippingBatchPushOrderModal/services";
import { PushOrderResult } from "@/services/api/dropShipping/order";
import DropShippingBatchPushOrderModal from "@/scenes/OrderManagement/components/dialogs/DropShippingBatchPushOrderModal";

interface DropShippingSubmitButtonProps {
    order: OrderDTO;
}

/**
 * 提交订单到供货商按钮
 */
const DropShippingSubmitButton: React.FC<DropShippingSubmitButtonProps> = function (props) {
    const { order } = props;
    const companySettingStore = useCompanySettingStore();
    const modalStore = useModalStore();
    const orderManagementStore = useOrderManagementStore();
    const globalStore = useGlobalStore();

    const onSuccess = (pushOrderResults: PushOrderResult[]) => {
        const pushOrderResult = pushOrderResults.find(({ retailerOrderId }) => retailerOrderId === order.id);
        if (!pushOrderResult) return;

        orderManagementStore.table.updateOrder(order.id, {
            retailerDropShippingInfo: pushOrderResult.retailerDropShippingInfo,
        });
    };

    const onRefresh = () => {
        orderManagementStore.fetchOrders(order.shopId);
    };

    async function handleClick(e) {
        e.preventDefault();

        const { errorNodes } = getValidOrders(globalStore, [order]);

        if (errorNodes?.length) {
            return Modal.error({ title: "提交订单失败", content: errorNodes });
        }

        const filterOrders = await preValidateAndFilterOrdersOrExecOperation(
            globalStore,
            modalStore,
            [order],
            companySettingStore.ensureHintBlacklistDetail,
            onRefresh,
        );

        modalStore.openModal(DropShippingBatchPushOrderModal, {
            orders: filterOrders,
            onSuccess,
            shopId: filterOrders[0].shopId,
            batch: false,
        });
    }

    return (
        <p className="mb5">
            <a href="#" onClick={handleClick}>
                提交订单
            </a>
        </p>
    );
};

export default observer(DropShippingSubmitButton);
